// F-V / F-W: batch "Generate Narration Audio" — the plan endpoints and the
// per-slot generate call, for both content kinds that carry narration.

import { getApiClient } from "./client";
import type { components } from "./types";
import { generateExhibitNarration } from "./exhibits";
import { generateZoneNarration } from "./zones";

export type NarrationKind = "exhibit" | "zone";
export type NarrationStatus = components["schemas"]["NarrationStatus"];
export type NarrationPlanItem = components["schemas"]["NarrationPlanItem"];
export type NarrationPlan = components["schemas"]["NarrationPlanResponse"];

/** Read-only plan: every slot's status + billable characters + budget. */
export async function planNarration(
  kind: NarrationKind,
  ids: string[],
): Promise<NarrationPlan> {
  const { data } =
    kind === "exhibit"
      ? await getApiClient().post<NarrationPlan>(
          "/staff/exhibits/narration-plan",
          { exhibitIds: ids },
        )
      : await getApiClient().post<NarrationPlan>(
          "/staff/zones/narration-plan",
          { zoneIds: ids },
        );
  return data;
}

/** Generate one slot through the existing per-owner endpoint (quota gate,
 *  metering, scope check and audit all stay server-side). */
export async function generateNarration(
  kind: NarrationKind,
  ownerId: string,
  language: string,
): Promise<void> {
  if (kind === "exhibit") await generateExhibitNarration(ownerId, language);
  else await generateZoneNarration(ownerId, language);
}

/** Staff edit page for an owner, opened at its Narration tab. */
export const narrationEditPath = (kind: NarrationKind, id: string): string =>
  `/staff/${kind}/${id}/edit#narration`;
